import React, { Component } from "react";
import { withGoogleMap, GoogleMap, Polygon } from "react-google-maps";

import { DrawingManager } from "react-google-maps/lib/components/drawing/DrawingManager";
import GoogleMapsLoader from "../GoogleMapsLoader";
import "./styles.css";
class PolygonMapComponent extends Component {
  constructor(props) {
    super(props);
    const initialCenter = { lat: -23.5505, lng: -46.6333 };
    const initialZoom = 13;

    this.state = {
      polygons: [],
      drawingEnabled: true,
      // preserve initial view so reset can restore it
      initialCenter,
      initialZoom,
      center: initialCenter,
      zoom: initialZoom,
    };
  }

  componentDidMount() {
    // Try to center the map on the user's current position. If permission is
    // denied or an error occurs, we keep the initial center.
    console.log("props", this.props);
    if (
      this.props.initialCoordinates &&
      this.props.initialCoordinates.length >= 3
    ) {
      console.log("initialCoordinates", this.props.initialCoordinates);
      this.setState({
        center: {
          lat: this.props.initialCoordinates[0].lat,
          lng: this.props.initialCoordinates[0].lng,
        },
        polygons: this.props.initialCoordinates,
        drawingEnabled: false,
        zoom: 14,
      });
    } else if (navigator && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const { latitude, longitude } = pos.coords;
          this.setState({
            center: { lat: latitude, lng: longitude },
            initialCenter: { lat: latitude, lng: longitude },
            zoom: 14,
          });
        },
        (err) => {
          // ignore error and keep default center
          console.warn(
            "Geolocation error, using default center:",
            err && err.message
          );
        },
        { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
      );
    }
  }

  handlePolygonComplete = (polygon) => {
    if (
      this.props.initialCoordinates &&
      this.props.initialCoordinates.length >= 3
    )
      return;
    console.log("Polygon complete called", polygon);
    const path = polygon
      .getPath()
      .getArray()
      .map((coord) => ({
        lat: coord.lat(),
        lng: coord.lng(),
      }));
    // Ensure polygon coordinates are closed (first === last). Many formats
    // such as GeoJSON require the linear ring to have the first coordinate
    // repeated at the end.
    const epsilon = 1e-6;
    function equal(a, b) {
      return (
        Math.abs(a.lat - b.lat) < epsilon && Math.abs(a.lng - b.lng) < epsilon
      );
    }

    if (path.length > 0 && !equal(path[0], path[path.length - 1])) {
      path.push({ ...path[0] });
    }

    console.log("Área desenhada (fechada):", path);
    // Only allow a single polygon on screen. If you want to replace the
    // existing polygon, reset first or ignore additional polygons.
    this.setState({ polygons: [path], drawingEnabled: false });
    // notify parent with closed ring
    if (this.props.handlePolygonComplete)
      this.props.handlePolygonComplete(path);
    // remove the transient polygon drawn by DrawingManager
    polygon.setMap(null);
  };

  render() {
    const { polygons, drawingEnabled, center, zoom } = this.state;

    console.log(polygons);

    return (
      <div className="polygonMap" style={{ display: "flex", padding: 15 }}>
        <div style={{ marginTop: 0, marginRight: 10 }}>
          <button
            type="button"
            className="btn btn-default btn-sm"
            style={{
              width: "130px",
              height: "30px",
              backgroundColor: "orange",
              color: "white",
              fontWeight: "bold",
            }}
            onClick={() =>
              this.setState((prev) => ({
                polygons: [],
                drawingEnabled: true,
                center: prev.initialCenter,
                zoom: prev.initialZoom,
              }))
            }
          >
            Reiniciar Mapa
          </button>
        </div>

        <GoogleMap center={center} zoom={zoom}>
          {this.state.drawingEnabled && (
            <DrawingManager
              onPolygonComplete={this.handlePolygonComplete}
              defaultOptions={{
                drawingControl: true,
                drawingControlOptions: {
                  drawingModes: ["polygon"],
                },
                polygonOptions: {
                  fillColor: "#FF0000",
                  fillOpacity: 0.4,
                  strokeColor: "#FF0000",
                  strokeWeight: 2,
                  clickable: true,
                  editable: false,
                  zIndex: 1,
                },
              }}
            />
          )}

          {polygons.map((coords, i) => (
            <Polygon
              key={i}
              path={coords}
              options={{
                fillColor: "#00FFAA",
                fillOpacity: 0.4,
                strokeColor: "#008800",
                strokeWeight: 2,
              }}
            />
          ))}
        </GoogleMap>
      </div>
    );
  }
}

const WrappedMap = withGoogleMap(PolygonMapComponent);

export default function PolygonMap(props) {
  const url = props.googleMapsUrl; // optional override
  return (
    <GoogleMapsLoader url={url}>
      <WrappedMap {...props} />
    </GoogleMapsLoader>
  );
}



// WEBPACK FOOTER //
// ./src/components/PolygonMap/index.js